import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {ValidatorFn, Validators} from '@angular/forms';
import {RepublicaMovilService} from '../../services/republica-movil.service';
import {cifValidator, dniValidator, getMaxLengthByDoc, nieValidator} from '../../../utils/validators/spanish-id-validator';
import {environment} from '../../../../environments/environment';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DialogData} from '../rm-user-data/rm-user-data.component';
import { brands } from 'src/app/shared/constantes';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-rm-user-banking-data',
    templateUrl: './rm-user-banking-data.component.html',
    styleUrls: ['./rm-user-banking-data.component.css', '../../../../assets/css/rm-theme.css'],
    standalone: false
})
export class RmUserBankingDataComponent implements OnInit, OnDestroy {
    public documentTypes = [];
    public countries = [];
    public country = environment.googleMapsCountry;
    public requireCif = false;
    public maxLengthByDoc = 9;
    private allSubscription: Subscription[] = [];

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: DialogData,
        public dialogRef: MatDialogRef<RmUserBankingDataComponent>,
        private rmService: RepublicaMovilService
    ) { }

    ngOnInit(): void {
        this.allSubscription.push(this.rmService.getDocumentTypes()
            .subscribe((data: any) => {
                if (data != null) {
                    this.documentTypes = data;
                }
            })
        );

        this.allSubscription.push(this.rmService.getCountries()
            .subscribe((data: any) => {
                if (data != null) {
                    this.countries = data;
                }
            })
        );

        this.changeTypeDocument(this.data.formGroup.get('account_doctype').value);
    }

    copyUserData() {
        const userData = this.data.formGroup.getRawValue();

        this.data.formGroup.get('account_doctype').patchValue(userData.doctype);
        this.data.formGroup.get('account_doc').patchValue(userData.doc);
        this.data.formGroup.get('account_country').patchValue(userData.country);
        this.data.formGroup.get('account_firstName').patchValue(userData.firstName);
        this.data.formGroup.get('account_surname1').patchValue(userData.surname1);
        this.data.formGroup.get('account_surname2').patchValue(userData.surname2);
        this.data.formGroup.get('account_surname2').patchValue(userData.surname2);
        this.data.formGroup.get('account_company').patchValue(userData.company);

        this.changeTypeDocument(userData.doctype);
    }

    changeTypeDocument(value) {
        const docValidators: ValidatorFn[] = [Validators.required];

        if (typeof value === 'number') {
            value = value.toString();
        }

        this.requireCif = value === '4';

        if (this.requireCif) {
            this.data.formGroup.get('account_company').setValidators(Validators.required);
        } else {
            this.data.formGroup.get('account_company').clearValidators();
        }

        switch (value) {
            case '1':
                docValidators.push(dniValidator());
                break;
            case '2':
                if (this.data.formGroup.get('account_country').value === 'ES') {
                    this.data.formGroup.get('account_country').patchValue(null);
                }
                docValidators.push(nieValidator());
                break;
            case '4':
                docValidators.push(cifValidator());
                break;
            default:
        }

        this.data.formGroup.get('account_doc').setValidators(docValidators);
        this.data.formGroup.get('account_doc').updateValueAndValidity();
        this.data.formGroup.get('account_company').updateValueAndValidity();
    }

    save() {
        if (this.validate()) {
            this.dialogRef.close(this.data);
        }
    }

    validate(): boolean {
        this.data.formGroup.markAllAsTouched();
        this.data.formGroup.updateValueAndValidity();

        if (
            this.data.formGroup.get('account_doctype').valid &&
            this.data.formGroup.get('account_doc').valid &&
            this.data.formGroup.get('account_country').valid &&
            this.data.formGroup.get('account_firstName').valid &&
            this.data.formGroup.get('account_surname1').valid &&
            this.data.formGroup.get('account_surname2').valid &&
            this.data.formGroup.get('account_surname2').valid &&
            this.data.formGroup.get('account_company').valid
        ) {
            return true;
        } else {
            const elements: any = document.getElementsByClassName('mat-input-element ng-invalid');
            if (elements.length > 0) {
                elements[0].focus();
            }
            return false;
        }
    }

    setMaxLengthByDoc(type) {
        this.maxLengthByDoc = getMaxLengthByDoc(brands.rm, type);
    }

    ngOnDestroy() {
        if (this.allSubscription && this.allSubscription.length) {
            this.allSubscription.map(subs => subs.unsubscribe());
        }
    }
}
